import React, { useEffect, useRef, useState } from 'react';
import { TVTextFieldProps } from '.';
import { TextField } from '@mui/material';
import { useField } from '@unform/core';

const CepFormat = (value: string): string => {
  const cleanValue = value.replace(/\D/g, '').slice(0, 8);
  if (cleanValue.length <= 5) return cleanValue;
  return `${cleanValue.slice(0, 5)}-${cleanValue.slice(5)}`;
};

export const VTextFieldCEP: React.FC<TVTextFieldProps> = ({ name, ...rest }) => {
  const { fieldName, registerField, defaultValue, error, clearError } = useField(name);

  const [value, setValue] = useState(defaultValue || '');
  const valueRef = useRef(value);
  valueRef.current = value;

  useEffect(() => {
    registerField({
      name: fieldName,
      getValue: () => valueRef.current.replace(/\D/g, ''),
      setValue: (_, newValue) => setValue(newValue),
      clearValue: () => setValue(''),
    });
  }, [registerField, fieldName]);

  const handleCepChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const raw = event.target.value;
    setValue(CepFormat(raw));
    rest.onChange?.(event);
  };

  return (
    <TextField
      name={name}
      {...rest}
      fullWidth
      error={!!error}
      helperText={error || ' '}
      value={value}
      onChange={handleCepChange}
      onKeyDown={(e) => { error && clearError(); rest.onKeyDown?.(e); }}
      inputProps={{ maxLength: 9 }}
    />
  );
};
